/* tslint:disable */
/* eslint-disable */
/**
 * PRMGApp
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function ProtocolHtmlRequestFromJSON(json) {
    return ProtocolHtmlRequestFromJSONTyped(json, false);
}
export function ProtocolHtmlRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'protocolId': !exists(json, 'protocolId') ? undefined : json['protocolId'],
        'html': !exists(json, 'html') ? undefined : json['html'],
        'overwrite': !exists(json, 'overwrite') ? undefined : json['overwrite'],
    };
}
export function ProtocolHtmlRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'protocolId': value.protocolId,
        'html': value.html,
        'overwrite': value.overwrite,
    };
}
